import React, { forwardRef, memo } from 'react';
import { fastHalve } from '../fastMaths';

const SvgScrollbarGrabber = memo(
    forwardRef(({ length = 63, ...props }, ref) => {
        if (isNaN(length)) {
            length = 63;
        }

        const pathCentreVerticalPos = fastHalve(length + 0.75);

        return (
            <svg
                ref={ref}
                width={16}
                height={length}
                viewBox={`0 0 16 ${length}`}
                {...props}
            >
                <g fillRule='evenodd'>
                    <rect
                        ry={2}
                        rx={2}
                        y={0.5}
                        x={0.5}
                        height={length - 1}
                        width={15}
                        fill='#b2b2b2'
                        stroke='#a2a2a2'
                    />
                    <path
                        fill='#fff'
                        stroke='#fff'
                        strokeWidth={2}
                        d={`M4 ${
                            pathCentreVerticalPos - 6
                        }h8v1H4zM4 ${pathCentreVerticalPos}h8v1H4zM4 ${
                            pathCentreVerticalPos + 6
                        }h8v1H4z`}
                    />
                </g>
            </svg>
        );
    })
);

SvgScrollbarGrabber.displayName = 'SvgScrollbarGrabber';

export default SvgScrollbarGrabber;
